let isLoading = false;
const loadItems = (button) => {
    if (isLoading) {
        return;
    }
    isLoading = true;
    const totalPages = parseInt($('[data-total-pages]').val());
    const currentPage = parseInt($('[data-current-page]').val());
    const nextUrl = $('[data-next-url]').val();

  console.log(totalPages);
  console.log(currentPage);
  console.log(nextUrl);
  
    button.setAttribute("disabled", "");
    button.classList.add('loading');

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
        const newScrollData = $(responseHTML).find('.infinite-scroll__data');
        if (newScrollData.length) {
          $('.infinite-scroll__data').replaceWith(newScrollData);
        }
        if (typeof colorSwatches === 'function') {
          colorSwatches();
        }
      },
      complete: function() {
        isLoading = false;
        const newCurrentPage = parseInt($('[data-current-page]').val());
        const totalPages = parseInt($('[data-total-pages]').val());

        if (newCurrentPage >= totalPages) {
          button.remove();
        } else {
          checkVisibility();
          button.removeAttribute("disabled");
          button.classList.remove('loading');
        }
      }
    })
  }
  
const checkVisibility = () => {
  console.log('checking visibility');
  const spinner = document.querySelector('.js-infinite-scroll');

  if (!spinner) {
    return;
  }

  const sectionObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          console.log('carico items');
          loadItems(spinner);
        }
      });
    }
  );

  sectionObserver.observe(spinner);
};

  
  function loadMore() {  
    
  console.log('chiamato load more');
    document.querySelectorAll('.js-load-more').forEach((button) => {
      
  console.log('setto onclick');
      button.onclick = () => {
  console.log('onclick');
        loadItems(button);
      }
    });
  
    checkVisibility();
  }
  
  (function () {
    loadMore();
  })();